import pdtTrack from '@growth/pdt-track';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var LOAD_EVENT = 'OPEN-APP-BANNER-LOADED';
var CLICK_EVENT = 'OPEN-APP-BANNER-CLICK';
var CLOSE_EVENT = 'OPEN-APP-BANNER-CLOSE';
var CTA_TEXT_LOAD = 'growth_non_int_mweb2app_cta_text_load';
var TIMER_LOAD = 'growth_non_int_mweb2app_timer_load'; // PDT ONLY

var LINK_API_FAIL_EVENT = 'OPEN-APP-BANNER-LINK-API-FAIL';
var QR_API_FAIL_EVENT = 'OPEN-APP-BANNER-QR-API-FAIL';
var HOC_API_RESPONSE = 'growth_non_int_HOC_API_RESPONSE'; // TODO: break this object to seperate variables. TREE SHAKING!!!

var BANNER_TYPE = {
  TOP_BANNER: 'topbanner',
  BOTTOM_SHEET: 'bottomsheet',
  APP_DIALOG: 'appdialog',
  DESKTOP_DRAWER: 'desktopdrawer',
  DESKTOP_POPUP: 'dwebpip',
  INLINE_CARD: 'inlinecard',
  FULL_PAGE: 'fullpagesheet',
  MWEB_RECENT_SEARCH_CARD: 'mwebrecentsearchcard',
  BOTTOM_BAR: 'bottombar',
  INLINE_CARD_DESKTOP: 'inlinecarddesktop',
  FLOATING_BTN: 'floatingbtn'
};
var DWEB_RECENT_SEARCH_CARD = 'dwebrecentsearchcard';
var FIRST_PAGE_AS_SESSION = '_gr_fr-p'; // top banner first page

var CTA_TYPE = {
  PLAYSTORE: 'playstore',
  APPSTORE: 'appstore',
  QR_CODE: 'qrcode'
};
var hideTopBannerEventName = 'hideTopBanner';
var showTopBannerEventName = 'showTopBanner';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var PdtInstance = function PdtInstance() {
  var commonKeys;
  return {
    setCommonKeys: function setCommonKeys(_ref) {
      var action = _ref.action,
          campaign = _ref.campaign,
          bannerType = _ref.bannerType,
          tagid = _ref.tagid,
          lobName = _ref.lobName,
          page = _ref.page,
          experimentKey = _ref.experimentKey,
          experimentValue = _ref.experimentValue,
          uuid = _ref.uuid,
          trafficSource = _ref.trafficSource;
      commonKeys = {
        event_details: {
          action: action,
          utm_campaign: campaign,
          item_selected: bannerType,
          tag: tagid,
          lob: lobName,
          screen_name: page,
          ab_experiment: experimentKey + ":" + experimentValue
        },
        user: {
          uuid: uuid
        },
        device: {
          traffic_source: trafficSource || 'direct'
        }
      };
    },
    sendPdtEvent: function sendPdtEvent(eventDetails) {
      pdtTrack({
        event_details: _extends({}, commonKeys.event_details, eventDetails),
        device: commonKeys.device,
        user: commonKeys.user
      });
    }
  };
};

export { BANNER_TYPE as B, CLICK_EVENT as C, DWEB_RECENT_SEARCH_CARD as D, FIRST_PAGE_AS_SESSION as F, HOC_API_RESPONSE as H, LOAD_EVENT as L, PdtInstance as P, QR_API_FAIL_EVENT as Q, TIMER_LOAD as T, _taggedTemplateLiteralLoose as _, _extends as a, CTA_TYPE as b, LINK_API_FAIL_EVENT as c, CTA_TEXT_LOAD as d, CLOSE_EVENT as e, hideTopBannerEventName as h, showTopBannerEventName as s };
